<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container"
    content-class="modal-medium"
    title="エクストラサイト一覧(Type4)"
  >
    <template v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="mb-2">
              <v-col class="text-right">
                <v-btn color="primary" @click="toAddSite">追加</v-btn>
              </v-col>
            </v-row>
            <app-table
              v-model:table-sort-by="siteList.sortBy"
              :fields="siteList.fields"
              :items="siteList.items"
              :hover="true"
              :per-page="-1"
              primary-key="siteId"
              @click:row="extraSelected"
            >
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn variant="outlined" color="primary" @click="cancel"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { Type4ExtraSite, Type4ExtraSiteList } from "@/apis/Type4SiteApi";
import type { ApplianceInfo } from "@/apis/ContractApi";
import type { SortItem } from "@/components/AppTable.vue";
import Type4ExtraSiteEdit from "@/modals/type4/Type4ExtraSiteEdit.vue";
import Type4ExtraSiteReference from "@/modals/type4/Type4ExtraSiteReference.vue";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "Type4ExtraSiteList",
  props: {
    extraSite: {
      type: Object as PropType<Type4ExtraSite>,
      required: true,
    },
    type4Id: {
      type: String as PropType<ApplianceInfo["type4Id"]>,
      required: true,
    },
  },
  data() {
    return {
      siteList: {
        sortBy: {
          key: "siteName",
          order: "asc",
        } as SortItem,
        fields: [
          {
            key: "siteName",
            title: "サイト名",
            sortable: true,
          },
        ],
        items: [] as Type4ExtraSiteList[],
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    /** 初期化機能 */
    load() {
      this.siteList.items = this.extraSite.siteList;
    },
    /** 追加機能 */
    async toAddSite() {
      await this.$modal.show(Type4ExtraSiteEdit, {
        type4Id: this.type4Id,
        type4SiteKeyId: this.extraSite.type4SiteKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** 行選択機能 */
    async extraSelected(item: Type4ExtraSiteList) {
      await this.$modal.show(Type4ExtraSiteReference, {
        extraSite: item,
        type4Id: this.type4Id,
        type4SiteKeyId: this.extraSite.type4SiteKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
